export const rewardPrograms = {
  lossback: {
    title: "10% Weekly Lossback",
    description: "Had a tough week? Get 10% back on your weekly losses.",
  },
  wager: {
    title: "Wager Rewards",
    description: "Reach wager milestones and claim wager rewards.",
  },
  leaderboard: {
    title: "$25,000 Monthly Leaderboard",
    description: "Compete each month for a share of our $25,000 prize pool.",
  },
  reload: {
    title: "$21.00 Reload Bonus",
    description: "Every player who signs up on Stake under GreenVenom gets a free $21.00 reload bonus.",
  },
};

export const reloadBonus = rewardPrograms.reload;

export const homeBenefitSummaries = {
  leaderboard: 'A $25,000 monthly race for players under code GREENVENOM: $20,000 on the regular leaderboard and $5,000 on the Stake-exclusive slots board. Build your qualifying wager total and race to the top!',
  lossback: 'Get 10% of your eligible weekly losses back when you play on Stake under code GREENVENOM. Weekly lossback offers a little back after a tough week—check the VIP rewards details for eligibility and claim requirements.',
  wager: 'Get up to $10,000 in extra bonuses and rewards through our Wager Rewards program. Play under code GREENVENOM, build your eligible wagering total, and claim rewards as you reach new tiers.',
  reload: 'Sign up on Stake under code GREENVENOM, deposit $5.00, then message Stake support to activate your $21.00 reload bonus.',
};

export const homeBenefitDetails = {
  leaderboard: {
    title: 'Monthly leaderboards', amount: '$25,000', amountLabel: 'Total monthly prize pool',
    description: 'A monthly race for GREENVENOM players. Build your qualifying wager total and race to the top.',
    facts: [{ label: 'Regular leaderboard', value: '$20,000' }, { label: 'Stake-exclusive slots', value: '$5,000' }],
  },
  lossback: {
    title: 'Weekly lossback', amount: '10%', amountLabel: 'Back on eligible weekly losses',
    description: 'A little back after a tough week. Eligible Stake players under GREENVENOM can receive weekly lossback.',
    facts: [{ label: 'Reward frequency', value: 'Weekly' }, { label: 'Calculated on', value: 'Eligible losses' }],
  },
  wager: {
    title: 'Wager rewards', amount: '$10,000', amountLabel: 'Wager-rewards program',
    description: 'Get up to $10,000 in extra bonuses and rewards through our Wager Rewards program. Play under GreenVenom and reach eligible wager milestones to claim your bonuses.',
    facts: [{ label: 'Progress through', value: 'Wager milestones' }, { label: 'Unlock', value: 'Level-up bonuses' }],
  },
  reload: {
    title: 'Welcome reload bonus', amount: '$21.00', amountLabel: 'Free reload bonus',
    description: 'Activate your $21.00 reload bonus in three simple steps.',
    steps: ['Sign up on Stake under code GREENVENOM.', 'Deposit $5.00 into your Stake account.', 'Message Stake support to activate your bonus.'],
  },
};

export const REWARDS_DISCORD_URL = "https://discord.gg/greenvenom";